import { render, staticRenderFns } from "./AdminProductsList.vue?vue&type=template&id=645f98ff&scoped=true"
import script from "./AdminProductsList.vue?vue&type=script&lang=js"
export * from "./AdminProductsList.vue?vue&type=script&lang=js"
import style0 from "./AdminProductsList.vue?vue&type=style&index=0&id=645f98ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f98ff",
  null
  
)

export default component.exports